export default __webpack_public_path__ + "d5b5922526a60e5d08a450a6a875beac.jpg";